<template>
  <div class="l-container FamiliesIndex">
    <!-- <splitpanes> -->
    <!--   <span> -->
    <span style="margin-top: 10px; display: inline-block">現在表示数 : {{max}} </span>

    <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'mgr'">
      <export-modal class="export-modal" :obj="obj" :columns="columns" @swi="switchV" @res="reset" @all="all" @def="def">Export</export-modal>
    </template>

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span v-for="(list, index) in columns" :key="index">
      <template v-if="sortColumn === columns[index].code">
        {{ list.name }} : {{sortState}}
      </template>
    </span>

    <h1 class="m-label m-label-custom" @click="switchColumns('columnsFlg')" v-bind:class="{ 'slideActive': columnsFlg }" v-ripple>項目</h1>

    <template v-if="columnsFlg">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="def()">DEFAULT</btn>

        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchV(index)" v-bind:class="{ 'active': columns[index].show }">{{ list.name }}</btn>

      </div>
    </template>

    <btn class="m-btn resetSearch" @click.native="resetSearch">Reset</btn>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <template v-if="columns[0].show"><td-c class="sticky-1"><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.company_id" :options="companies" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[4].show"><td-c class="sticky-1"><input v-model="search.latest" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="columns[5].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[6].show"><td-c class="sticky-1"><input v-model="search.name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[7].show"><td-c class="sticky-1"><input v-model="search.kana" type="text" @keyup="searchTable()" v-focus></td-c></template>
          <template v-if="columns[8].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.relationship" :options="relationship" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[9].show"><td-c class="sticky-1"><input v-model="search.zip" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[10].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[11].show"><td-c class="sticky-1"><input v-model="search.address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[12].show"><td-c class="sticky-1"><input v-model="search.tel1" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[13].show"><td-c class="sticky-1"><input v-model="search.tel2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[14].show"><td-c class="sticky-1"><input v-model="search.fax" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[15].show"><td-c class="sticky-1"><input v-model="search.mail" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[16].show"><td-c class="sticky-1"><input v-model="search.mail2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[17].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.guidance_type" :options="guidance_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[18].show"><td-c class="sticky-1"><input v-model="search.structure" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.unit" :options="unit" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show"><td-c class="sticky-1"><input v-model="search.workplace_contact" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[21].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.preferred_contact" :options="preferred_contact" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[22].show"><td-c class="sticky-1"><input v-model="search.contact_timezone" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[23].show"><td-c class="sticky-1"><input v-model="search.withdrawal_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[24].show"><td-c class="sticky-1"><input v-model="search.note1" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[25].show"><td-c class="sticky-1"><input v-model="search.note2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[26].show"><td-c class="sticky-1"><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="columns[0].show"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_company_id" :options="companies" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[4].show"><td-c class="sticky-2"><input v-model="search.not_latest" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
          <template v-if="columns[5].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[6].show"><td-c class="sticky-2"><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[7].show"><td-c class="sticky-2"><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[8].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_relationship" :options="relationship" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[9].show"><td-c class="sticky-2"><input v-model="search.not_zip" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[10].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[11].show"><td-c class="sticky-2"><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[12].show"><td-c class="sticky-2"><input v-model="search.not_tel1" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[13].show"><td-c class="sticky-2"><input v-model="search.not_tel2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[14].show"><td-c class="sticky-2"><input v-model="search.not_fax" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[15].show"><td-c class="sticky-2"><input v-model="search.not_mail" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[16].show"><td-c class="sticky-2"><input v-model="search.not_mail2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[17].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_guidance_type" :options="guidance_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[18].show"><td-c class="sticky-2"><input v-model="search.not_structure" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_unit" :options="unit" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show"><td-c class="sticky-2"><input v-model="search.not_workplace_contact" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[21].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_preferred_contact" :options="preferred_contact" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[22].show"><td-c class="sticky-2"><input v-model="search.not_contact_timezone" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[23].show"><td-c class="sticky-2"><input v-model="search.not_withdrawal_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[24].show"><td-c class="sticky-2"><input v-model="search.not_note1" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[25].show"><td-c class="sticky-2"><input v-model="search.not_note2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[26].show"><td-c class="sticky-2"><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c v-for="(list, index) in columns" :key="index" v-if="columns[index].show" class="sticky-3" @click.native='sort(columns[index].code)'>{{ list.name }}</th-c>
        </tr-c>

        <tr-c @click.native='linkFamily($event, list)' slot="tr-td" v-for="(list, index) in mapFamilies" :key="index.id" class="tr_hover">
          <template v-if="columns[0].show"><td-c>{{list.id}}</td-c></template>
          <template v-if="columns[1].show">
            <td-c v-if="list.company_id === 0"></td-c>
            <td-c v-if="list.company_id !== 0">{{list.company.name}}</td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c>{{list.mapOffice}}</td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c v-if="list.user">{{list.user.user}}</td-c>
            <td-c v-else></td-c>
          </template>
          <template v-if="columns[4].show"><td-c>{{list.latest}}</td-c></template>
          <template v-if="columns[5].show">
            <td-c>
              <span v-for="(list, index) in list.students" :key=index>
                <template>{{list.mapState}}</template>
              </span>
            </td-c>
          </template>
          <template v-if="columns[6].show"><td-c>{{list.f_name}} {{list.l_name}}</td-c></template>
          <template v-if="columns[7].show"><td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c></template>
          <template v-if="columns[8].show"><td-c>{{list.mapRelationship}}</td-c></template>
          <template v-if="columns[9].show"><td-c>{{list.zip}}</td-c></template>
          <template v-if="columns[10].show"><td-c>{{list.mapPref}}</td-c></template>
          <template v-if="columns[11].show"><td-c>{{list.address1}}{{list.address2}}</td-c></template>
          <template v-if="columns[12].show"><td-c>{{list.tel1}}</td-c></template>
          <template v-if="columns[13].show"><td-c>{{list.tel2}}</td-c></template>
          <template v-if="columns[14].show"><td-c>{{list.fax}}</td-c></template>
          <template v-if="columns[15].show"><td-c>{{list.mail}}</td-c></template>
          <template v-if="columns[16].show"><td-c>{{list.mail2}}</td-c></template>
          <template v-if="columns[17].show"><td-c>{{list.mapGuidance_type}}</td-c></template>
          <template v-if="columns[18].show"><td-c>{{list.structure}}</td-c></template>
          <template v-if="columns[19].show"><td-c>{{list.mapUnit}}</td-c></template>
          <template v-if="columns[20].show"><td-c>{{list.workplace_contact}}</td-c></template>
          <template v-if="columns[21].show"><td-c>{{list.mapPreferred_contact}}</td-c></template>
          <template v-if="columns[22].show"><td-c>{{list.contact_timezone}}</td-c></template>
          <template v-if="columns[23].show"><td-c>{{list.withdrawal_date}}</td-c></template>
          <template v-if="columns[24].show"><td-c>{{list.note1}}</td-c></template>
          <template v-if="columns[25].show"><td-c>{{list.note2}}</td-c></template>
          <template v-if="columns[26].show"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
        </tr-c>
      </table-c>
    </div>
    <!--   </span> -->
    <!--   <span splitpanes&#45;default="65"> -->
    <!--     test -->
    <!--   </span> -->
    <!-- </splitpanes> -->
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/families/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  exportUrl: url,
  pageName: 'family',
  pageNames: 'families'
}

let _ = window._
export default {
  directives: {
    focus: {
      inserted: function (el, binding) {
        el.focus()
      }
    }
  },
  data () {
    return {
      sortState: '降順',
      sortColumn: 'id',

      columnsFlg: false,

      columns: [
        {
          code: 'id',
          name: 'ID',
          show: true,
          def: true,
          search: ''
        },
        {
          code: 'company_id',
          name: '会社名',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'office_id',
          name: '営業所',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'user_id',
          name: '登録者',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'latest',
          name: '最新契約日',
          show: true,
          def: true,
          search: ''
        },
        {
          code: 'state',
          name: '状態',
          show: true,
          def: true,
          search: ''
        },
        {
          code: 'name',
          name: '名前',
          show: true,
          def: true,
          search: ''
        },
        {
          code: 'kana',
          name: 'かな',
          show: true,
          def: true,
          search: ''
        },
        {
          code: 'relationship',
          name: '続柄',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'zip',
          name: '郵便番号',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'pref',
          name: '都道府県',
          show: true,
          def: true,
          search: ''
        },
        {
          code: 'address',
          name: '住所',
          show: true,
          def: true,
          search: ''
        },
        {
          code: 'tel1',
          name: '携帯TEL',
          show: true,
          def: true,
          search: ''
        },
        {
          code: 'tel2',
          name: '固定TEL',
          show: true,
          def: true,
          search: ''
        },
        {
          code: 'fax',
          name: 'FAX',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'mail',
          name: 'MAIL',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'mail2',
          name: 'MAIL2',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'guidance_type',
          name: '指導種類',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'structure',
          name: '家族構成',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'unit',
          name: '件口',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'workplace_contact',
          name: '勤め先連絡先',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'preferred_contact',
          name: '優先連絡先',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'contact_timezone',
          name: '連絡曜日時間帯',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'withdrawal_date',
          name: '退会日',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'note1',
          name: '備考1',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'note2',
          name: '備考2',
          show: false,
          def: false,
          search: ''
        },
        {
          code: 'created_at',
          name: '作成日',
          show: false,
          def: false,
          search: ''
        }
      ],

      search: {
        id: '',
        company_id: '',
        office_id: '',
        user_id: '',
        latest: '',
        state: '',
        name: '',
        kana: '',
        relationship: '',
        zip: '',
        pref: '',
        address: '',
        tel1: '',
        tel2: '',
        fax: '',
        mail: '',
        mail2: '',
        guidance_type: '',
        structure: '',
        unit: '',
        workplace_contact: '',
        preferred_contact: '',
        contact_timezone: '',
        withdrawal_date: '',
        note1: '',
        note2: '',
        created_at: '',

        not_id: '',
        not_company_id: '',
        not_office_id: '',
        not_user_id: '',
        not_latest: '',
        not_state: '',
        not_name: '',
        not_kana: '',
        not_relationship: '',
        not_zip: '',
        not_pref: '',
        not_address: '',
        not_tel1: '',
        not_tel2: '',
        not_fax: '',
        not_mail: '',
        not_note1: '',
        not_note2: '',
        not_created_at: ''
      },

      watch: {
        user_id: '',
        company_id: '',
        office_id: '',
        state: '',
        relationship: '',
        pref: '',
        guidance_type: '',
        unit: '',
        preferred_contact: '',

        not_user_id: '',
        not_company_id: '',
        not_office_id: '',
        not_state: '',
        not_relationship: '',
        not_pref: '',
        not_guidance_type: '',
        not_unit: '',
        not_preferred_contact: ''
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    state () {
      return this.$store.getters['students/state']
    },

    relationship () {
      return this.$store.getters['families/relationship']
    },

    guidance_type () {
      return this.$store.getters['families/guidance_type']
    },

    unit () {
      return this.$store.getters['families/unit']
    },

    preferred_contact () {
      return this.$store.getters['families/preferred_contact']
    },

    max () {
      return this.$store.getters.max
    },

    families () {
      return this.$store.getters.families
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    companies () {
      return this.$store.getters.companies
    },

    offices () {
      return this.$store.getters.offices
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    },

    // order By
    orderedFamilies () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.families, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.families, this.sortColumn)
      }
    },

    mapFamilies () {
      let self = this
      return self.orderedFamilies.map(family => {
        family.latest = self.contract_dateLatest(family)
        family.mapOffice = self.calcArry(family.office_id, 'offices')
        family.mapPref = self.calcArry(family.pref, 'prefs')
        family.mapRelationship = self.calcSelect(family.relationship, 'relationship')
        family.mapGuidance_type = self.calcSelect(family.guidance_type, 'guidance_type')
        family.mapUnit = self.calcSelect(family.unit, 'unit')
        family.mapPreferred_contact = self.calcSelect(family.preferred_contact, 'preferred_contact')
        family.students.map(student => {
          student.mapState = self.calcSelect(student.state, 'state')
          return student
        })
        return family
      })
    }
  },
  watch: {
    'watch.company_id': function (now, old) {
      if (now) {
        this.search.company_id = now.id
      } else {
        this.search.company_id = ''
      }
    },

    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.state': function (now, old) {
      if (now) {
        this.search.state = now.value
      } else {
        this.search.state = ''
      }
    },

    'watch.not_company_id': function (now, old) {
      if (now) {
        this.search.not_company_id = now.id
      } else {
        this.search.not_company_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    },

    'watch.relationship': function (now, old) {
      if (now) {
        this.search.relationship = now.value
      } else {
        this.search.relationship = ''
      }
    },

    'watch.not_relationship': function (now, old) {
      if (now) {
        this.search.not_relationship = now.value
      } else {
        this.search.not_relationship = ''
      }
    },

    'watch.pref': function (now, old) {
      if (now) {
        this.search.pref = now.id
      } else {
        this.search.pref = ''
      }
    },

    'watch.not_pref': function (now, old) {
      if (now) {
        this.search.not_pref = now.id
      } else {
        this.search.not_pref = ''
      }
    },

    'watch.guidance_type': function (now, old) {
      if (now) {
        this.search.guidance_type = now.value
      } else {
        this.search.guidance_type = ''
      }
    },

    'watch.not_guidance_type': function (now, old) {
      if (now) {
        this.search.not_guidance_type = now.value
      } else {
        this.search.not_guidance_type = ''
      }
    },

    'watch.unit': function (now, old) {
      if (now) {
        this.search.unit = now.value
      } else {
        this.search.unit = ''
      }
    },

    'watch.not_unit': function (now, old) {
      if (now) {
        this.search.not_unit = now.value
      } else {
        this.search.not_unit = ''
      }
    },

    'watch.preferred_contact': function (now, old) {
      if (now) {
        this.search.preferred_contact = now.value
      } else {
        this.search.preferred_contact = ''
      }
    },

    'watch.not_preferred_contact': function (now, old) {
      if (now) {
        this.search.not_preferred_contact = now.value
      } else {
        this.search.not_preferred_contact = ''
      }
    }
  },
  methods: {
    calcArry (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    calcSelect (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.value === val
        })[0].name
      } else {
        return
      }
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    contract_dateLatest (family) {
      if (!family.students) {
        return
      }
      let contract_dates = []
      let contract_dateList = family.students.map((student) => {
        return student.agreements.map((agreement) => {
          return agreement.contract_date
        })
      })
      contract_dateList.forEach((student) => {
        student.forEach((contract_date) => {
          contract_dates.push(contract_date)
        })
      })

      return contract_dates.sort().reverse()[0]
    },

    // contract_dateFirst (family) {
    //   if (!family.students) {
    //     return
    //   }
    //   let contract_dates = []
    //   let contract_dateList = family.students.map((student) => {
    //     return student.agreements.map((agreement) => {
    //       return agreement.contract_date
    //     })
    //   })
    //   contract_dateList.forEach((student) => {
    //     student.forEach((contract_date) => {
    //       contract_dates.push(contract_date)
    //     })
    //   })
    //
    //   return contract_dates.sort()[0]
    // },

    linkFamily (event, family) {
      if (event.metaKey || event.ctrlKey) {
        let routeData = this.$router.resolve({name: 'familyindex', params: { id: family.id }}); window.open(routeData.href, '_blank')
      } else {
        const arr = [
          'id',
          'company_id',
          'office_id',
          'user_id',
          'f_name',
          'l_name',
          'f_name_kana',
          'l_name_kana',
          'relationship',
          'zip',
          'pref',
          'address1',
          'address2',
          'tel1',
          'tel2',
          'fax',
          'mail',
          'mail2',
          'guidance_type',
          'structure',
          'unit',
          'workplace_contact',
          'preferred_contact',
          'contact_timezone',
          'withdrawal_date',
          'note1',
          'note2'
        ]
        arr.forEach((item) => {
          this.$store.state.item.family[item] = family[item]
        })
        this.$router.push({name: 'familyindex', params: { id: family.id }})
      }
    },

    switchColumns (col) {
      this[col] = !this[col]
    },

    switchV (col) {
      this.columns[col].show = !this.columns[col].show
    },

    reset () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = false
      }
    },

    all () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = true
      }
    },

    def () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = this.columns[i].def
      }
    },

    sort (header) {
      console.log(header)
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      this.watch.company_id = 0
      this.watch.office_id = 0
      this.search.latest = ''
      this.watch.state = 0
      this.search.name = ''
      this.search.kana = ''
      this.watch.relationship = 0
      this.search.zip = ''
      this.watch.pref = 0
      this.search.address = ''
      this.search.tel1 = ''
      this.search.tel2 = ''
      this.search.fax = ''
      this.search.mail = ''
      this.search.mail2 = ''
      this.watch.guidance_type = 0
      this.search.structure = ''
      this.watch.unit = 0
      this.search.workplace_contact = ''
      this.watch.preferred_contact = 0
      this.search.contact_timezone = ''
      this.search.withdrawal_date = ''
      this.search.note1 = ''
      this.search.note2 = ''
      this.search.created_at = ''

      this.search.not_id = ''
      this.watch.not_company_id = 0
      this.watch.not_office_id = 0
      this.search.not_latest = ''
      this.watch.not_state = 0
      this.search.not_name = ''
      this.search.not_kana = ''
      this.watch.not_relationship = 0
      this.search.not_zip = ''
      this.watch.not_pref = 0
      this.search.not_address = ''
      this.search.not_tel1 = ''
      this.search.not_tel2 = ''
      this.search.not_fax = ''
      this.search.not_mail = ''
      this.search.not_mail2 = ''
      this.watch.not_guidance_type = 0
      this.search.not_structure = ''
      this.watch.not_unit = 0
      this.search.not_workplace_contact = ''
      this.watch.not_preferred_contact = 0
      this.search.not_contact_timezone = ''
      this.search.not_withdrawal_date = ''
      this.search.not_note1 = ''
      this.search.not_note2 = ''
      this.search.not_created_at = ''

      this.searchTable()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('FamiliesSearch')
      let obj = JSON.parse(getjson)

      vm.watch.company_id = obj['company_id']
      vm.watch.office_id = obj['office_id']
      vm.search.latest = obj['latest']
      vm.watch.state = obj['state']
      vm.search.name = obj['name']
      vm.search.kana = obj['kana']
      vm.watch.relationship = obj['relationship']
      vm.search.zip = obj['zip']
      vm.watch.pref = obj['pref']
      vm.search.address = obj['address']
      vm.search.tel1 = obj['tel1']
      vm.search.tel2 = obj['tel2']
      vm.search.fax = obj['fax']
      vm.search.mail = obj['mail']
      vm.search.mail2 = obj['mail2']
      vm.watch.guidance_type = obj['guidance_type']
      vm.search.structure = obj['structure']
      vm.watch.unit = obj['unit']
      vm.search.workplace_contact = obj['workplace_contact']
      vm.watch.preferred_contact = obj['preferred_contact']
      vm.search.contact_timezone = obj['contact_timezone']
      vm.search.withdrawal_date = obj['withdrawal_date']
      vm.search.note1 = obj['note1']
      vm.search.note2 = obj['note2']
      vm.search.created_at = obj['created_at']

      vm.watch.not_company_id = obj['not_company_id']
      vm.watch.not_office_id = obj['not_office_id']
      vm.search.not_latest = obj['not_latest']
      vm.watch.not_state = obj['not_state']
      vm.search.not_name = obj['not_name']
      vm.search.not_kana = obj['not_kana']
      vm.watch.not_relationship = obj['not_relationship']
      vm.search.not_zip = obj['not_zip']
      vm.watch.not_pref = obj['not_pref']
      vm.search.not_address = obj['not_address']
      vm.search.not_tel1 = obj['not_tel1']
      vm.search.not_tel2 = obj['not_tel2']
      vm.search.not_fax = obj['not_fax']
      vm.search.not_mail = obj['not_mail']
      vm.search.not_mail2 = obj['not_mail2']
      vm.watch.not_guidance_type = obj['not_guidance_type']
      vm.search.not_structure = obj['not_structure']
      vm.watch.not_unit = obj['not_unit']
      vm.search.not_workplace_contact = obj['not_workplace_contact']
      vm.watch.not_preferred_contact = obj['not_preferred_contact']
      vm.search.not_contact_timezone = obj['not_contact_timezone']
      vm.search.not_withdrawal_date = obj['not_withdrawal_date']
      vm.search.not_note1 = obj['not_note1']
      vm.search.not_note2 = obj['not_note2']
      vm.search.not_created_at = obj['not_created_at']

      for (let i = 0; i < vm.columns.length; i++) {
        const column = 'column_' + vm.columns[i].code
        vm.columns[i].show = obj[column]
      }

      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      company_id: this.watch.company_id,
      office_id: this.watch.office_id,
      latest: this.search.latest,
      state: this.watch.state,
      name: this.search.name,
      kana: this.search.kana,
      relationship: this.watch.relationship,
      zip: this.search.zip,
      pref: this.watch.pref,
      address: this.search.address,
      tel1: this.search.tel1,
      tel2: this.search.tel2,
      fax: this.search.fax,
      mail: this.search.mail,
      mail2: this.search.mail2,
      guidance_type: this.watch.guidance_type,
      structure: this.search.structure,
      unit: this.watch.unit,
      workplace_contact: this.search.workplace_contact,
      preferred_contact: this.watch.preferred_contact,
      contact_timezone: this.search.contact_timezone,
      withdrawal_date: this.search.withdrawal_date,
      note1: this.search.note1,
      note2: this.search.note2,
      created_at: this.search.created_at,

      not_company_id: this.watch.not_company_id,
      not_office_id: this.watch.not_office_id,
      not_latest: this.search.not_latest,
      not_state: this.watch.not_state,
      not_name: this.search.not_name,
      not_kana: this.search.not_kana,
      not_relationship: this.watch.not_relationship,
      not_zip: this.search.not_zip,
      not_pref: this.watch.not_pref,
      not_address: this.search.not_address,
      not_tel1: this.search.not_tel1,
      not_tel2: this.search.not_tel2,
      not_fax: this.search.not_fax,
      not_mail: this.search.not_mail,
      not_mail2: this.search.not_mail2,
      not_guidance_type: this.watch.not_guidance_type,
      not_structure: this.search.not_structure,
      not_unit: this.watch.not_unit,
      not_workplace_contact: this.search.not_workplace_contact,
      not_preferred_contact: this.watch.not_preferred_contact,
      not_contact_timezone: this.search.not_contact_timezone,
      not_withdrawal_date: this.search.not_withdrawal_date,
      not_note1: this.search.not_note1,
      not_note2: this.search.not_note2,
      not_created_at: this.search.not_created_at
    }

    for (let i = 0; i < this.columns.length; i++) {
      const column = 'column_' + this.columns[i].code
      obj[column] = this.columns[i].show
    }

    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('FamiliesSearch', setjson)
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.sticky-1 {
  position: sticky;
  z-index: 4;
  top: 0;
  background: #fff;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    top: -1px;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}
.sticky-2 {
  position: sticky;
  z-index: 3;
  top: 26px;
  background: #fff;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}
.sticky-3 {
  position: sticky;
  z-index: 2;
  top: 52px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}

.m-label-custom {
  position: relative;
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  /* box-shadow: 1px 1px 1px #ccc; */
  /* border: solid 1px #ccc; */
  height: calc(100vh - 200px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f015";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}

.export-modal {
  position: absolute;
  top: 48px;
  right: 9px;
}

.splitpanes__pane {
  justify-content: center;
  align-items: center;
  display: flex;
}

/* .splitpanes__pane span { */
/*   font-family: Helvetica, Arial, sans-serif; */
/*   color: #fff; */
/*   font-size: 5em; */
/*   opacity: 0.6; */
/* } */
</style>

<style lang="scss">
.FamiliesIndex {
  .multiselect {
    min-height: 23px;
    min-width: 110px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// FamiliesIndex.vue?bb2eee90